import { AVATAR_COLORS, AVATAR_FALLBACK_COLOR } from "components/hoc/Theme";

/** A person as the server describes them for an avatar. */
export interface AvatarPerson {
  id: number;
  name: string;
  initials: string;
  /** A palette token; null until the user has one. */
  color: string | null;
  /** Staff are circles, client users rounded squares. */
  shape: "circle" | "rounded";
  organization: string;
}

export function avatarFill(color: string | null | undefined): string {
  const known = color
    ? AVATAR_COLORS[color as keyof typeof AVATAR_COLORS]
    : undefined;
  return known ?? AVATAR_FALLBACK_COLOR;
}

export function avatarTooltip(person: AvatarPerson): string {
  return person.organization
    ? `${person.name} - ${person.organization}`
    : person.name;
}

/**
 * Which avatars a stack draws and which hide behind "+N". One extra person is
 * drawn rather than hidden: a "+1" chip takes the same room as the avatar.
 */
export function stackParts<T>(
  people: T[],
  max: number,
): { shown: T[]; hidden: T[] } {
  if (people.length <= max + 1) return { shown: people, hidden: [] };
  return { shown: people.slice(0, max), hidden: people.slice(max) };
}
